import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AlertTriangle, X } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

const DISMISS_KEY = 'profileCompletionDismissed';

const ProfileCompletionBanner: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1');

  if (!isAuthenticated || !user || user.phone_number || dismissed || location.pathname === '/profile') {
    return null;
  }

  return (
    <div className="w-full border-b border-amber-300 bg-amber-50 text-amber-900">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-sm">
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
        <span>
          Your profile is incomplete: add a phone number so drivers and passengers can reach you.{' '}
          <Link to="/profile?complete=1" className="font-semibold underline">Complete profile</Link>
        </span>
        <button
          aria-label="Dismiss"
          onClick={() => {
            sessionStorage.setItem(DISMISS_KEY, '1');
            setDismissed(true);
          }}
          className="ml-2 p-1 hover:bg-amber-100 rounded"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ProfileCompletionBanner;
